import { IApplicationState } from '../../types/redux';

export const selectRoomsCount = (state: IApplicationState) => state.marketTrand.roomsCount;
export const selectPeriod = (state: IApplicationState) => state.marketTrand.period;
